import { ApiResponse, useFetchData, useFetchLeagueData } from '~/core/api';
import { D3_CONTENT_SEARCH } from '~/core/constants';

import { GameLogPayload, Player, PlayerBio, PlayerNewsType } from './types';

export const usePlayerQuery = (id: string | undefined): ApiResponse<Player> =>
    useFetchLeagueData(`/player/${id}/landing`, id !== undefined);

export const usePlayerGameLogQuery = (
    id: string | undefined,
    season: number | undefined,
    gameType: number | undefined,
    isEnabled: boolean
): ApiResponse<GameLogPayload> =>
    useFetchLeagueData(`/player/${id}/game-log/${season ? `${season}/${gameType}` : 'now'}`, isEnabled);

export const usePlayerBioQuery = (id: string | undefined): ApiResponse<PlayerBio> =>
    useFetchData(`${D3_CONTENT_SEARCH}/players?tags.slug=playerid-${id}`, id !== undefined);

export const usePlayerNewsQuery = (playerId: string | undefined, teamId: number): ApiResponse<PlayerNewsType> =>
    useFetchData(`${D3_CONTENT_SEARCH}/stories?context.slug=teamid-${teamId}&tags.slug=playerid-${playerId}`);
